//import React from "react";
//import CardMarkerSmall from '../CockpitCards/CardMarkerSmall.jsx';
import CardMarkerLong from '../../../../components/CockpitCards/CardMarkerLong.jsx'


export default function DisclaimerCard() {

return(
<>
<CardMarkerLong

  headline = "GENERAL DISCLAIMER" 
  subtext = {"The genetic information presented here is intended for informational and educational puroses only. It is not a substitute for professional medical advice, diagnosis, or treatment. Users should alsways consult with a qualified healthcare provider or verified genetic counselor regarding any questions or concerns related to genetic findings. While careful efforts have been made to ensure accuracy and completeness, no guarantee is made that all data presented is free from errors or omissions. Interpretations of genetic variants, including pathogenicity, may evolve over time as new research emerges."}
  
/>


</> 
)
}

